import angular from 'angular';
import { isEqual, map } from 'lodash';
import ConfigsModule from '../../configs/configs';
import ResourcesModule from '../../resources/resources';
import ObservablesModule from '../../services/observables';
import template from './segmentsRule.jade';

export class SegmentsRuleController {
  /* @ngInject */
  constructor($filter, currentGame, currentUser, SegmentsResource, $scope) {
    this.translate = $filter('translate');
    this.$scope = $scope;
    this.SegmentsResource = SegmentsResource;
    this.currentUser = currentUser;
    this.rule = this.rule || {};
    this.gameSegments = [];
    currentGame.subscribe(game => this.game = game);
    this.availableLogicalFieldsObservable = new Rx.BehaviorSubject(null);

    this.$scope.$watch("vm.rule.validLogicOperators", (newValue, oldvalue) => {
      this.availableLogicalFieldsObservable.onNext(newValue);
    }, true);

    this.logicalFields = [
      {
        className: this.withDisabledClassName('layout__item u-1/1'),
        type: 'radioAndOr',
        key: 'logical',
        controller: /* @ngInject */ ($scope) => {
          this.availableLogicalFieldsObservable.subscribe((availableLogicalFields) => {
            if ($scope && $scope.$parent && availableLogicalFields) {
              $scope.$parent.fields[0].templateOptions.options = availableLogicalFields.map(value => {
                return {value: value, name: this.translate('$rule.' + value)};
              })
            }
          });
        },
        templateOptions: {
          label: '',
          required: true
        }
      }
    ];

    this.field_configs = _.assign(this.game.simplaex_field_configs,this.game.custom_field_configs);

    this.setupFields();
    this.builFields();
    this.setFallbackValues();
  }

  getSegments(game_id) {
    this.SegmentsResource.getList({game_id})
    .then(segments => this.gameSegments = segments.plain());
  }

  setFallbackValues() {
    if (_.indexOf(this.getDimensionsWithNullableInLastDays(), this.rule.dimension) > -1) {
      if(this.rule.inLastDays === undefined) { this.rule.inLastDays = 'lifetime'; }
    }
  }

  getDimensionsWithNullableInLastDays() {
    return _.chain(this.field_configs).pickBy((config) => {
      return _.isEqual(['$in_last_days'], config.comparisons);
    }).keys().value();
  }

  withDisabledClassName(className) {
    return this.currentUser.value.hasRole(['AGENCY','GD_ACCOUNT_MANAGER','GG_ACCOUNT_MANAGER']) ? `${className} disabled-by-role` : className;
  };

  buildMatchingSegmentField(fieldName) {
    return [
      {
        type: 'uiSelect',
        key: `${fieldName}_gameId`,
        className: 'layout__item u-2/7 uiselect-dropdown-fit-content',
        templateOptions: {
          label: 'Select Game',
          options: this.gameDeveloperGames.map(option => {
            return {
              value: option.id,
              name: `${option.name} (${option.id})`
            };
          }),
          required: true
        }
      },
      {
        type: 'uiSelectMultiple',
        key: fieldName,
        className: 'layout__item u-5/7 uiselect-dropdown-fit-content',
        templateOptions: {
          label: 'Select Segment',
          options: this.gameSegments.map(option => {
            return {
              value: option.id,
              name: `${option.name} (${option.id})`
            };
          }),
          required: true
        },
        controller: /* @ngInject */ function ($scope, SegmentsResource) {
          let fetchSegments = function($scope, SegmentsResource){
            if ($scope.model[`${fieldName}_gameId`] !== undefined) {
              $scope.to.loading = SegmentsResource.getList({game_id: $scope.model[`${fieldName}_gameId`]})
              .then(function (response) {
                $scope.to.options = response.plain().map(option => {
                  return {
                    value: option.id,
                    name: `${option.name} (${option.id})`
                  };
                })
              });
            }
          }

          $scope.$watch(`model.${fieldName}_gameId`, function (newValue, oldValue, theScope) {
            if (newValue !== oldValue && newValue !== undefined) {

              // when reading segment from server, first we only have the segment id and game_id is undefined,
              // in this we don't need to reset the segment id selection
              if (oldValue !== undefined) {
                $scope.model[fieldName] = undefined;
              }
              fetchSegments($scope, SegmentsResource);
            }
          });

          $scope.$watch(`model.${fieldName}`, function (newValue, oldValue, theScope) {
            if (newValue !== undefined && newValue.length > 0 && $scope.model[`${fieldName}_gameId`] === undefined) {
              SegmentsResource.one(newValue[0]).get().then(segment => {
                $scope.model[`${fieldName}_gameId`] = segment.game_id;
              });
            }
          });
        }
      },
    ];
  }

  builFields() {
    this.ruleFieldsForEachDimension = {};
    _.forEach(this.field_configs, (config, fieldName) => {
      let quantativeComparisons = _.filter(config.comparisons, comparison => {
        switch (comparison) {
          case '$gt':
          case '$gte':
          case '$lt':
          case '$lte':
          case '$eq':
          case '$ne':
          case '$in_last_days':
          case '$nin_last_days':
            return true;
          default:
            return false;
        }
      });
      let multiSelectComparisons = _.filter(config.comparisons, comparison => {
        switch (comparison) {
          case '$in':
          case '$nin':
            return true;
          default:
            return false;
        }
      });
      let inLastDaysComparison = _.find(config.comparisons, comparison => {
        return comparison === '$in_last_days' || comparison === '$nin_last_days';
      });
      let existsComparison = _.find(config.comparisons, comparison => {
        return comparison === '$exists'
      });
      let configArray = [];

      // currently FE supports only one possible type of query on a field
      // therefore, once we find a fitting segmentation we don't look for more.
      // this behaviour does not fit regDate or paidAmount fields, for example, which might be segmented in more than one fashion.
      // for the time being we would choose a "in_last_days" segmentation rather than simple quantitative segmentation.
      if (
        isEqual(config.semantics, ['timestamped_set']) &&
        isEqual(config.comparisons, ['$eq', '$in_last_days', '$nin_last_days'])
      ) {
        if (this.isAlphaNumericField(config)) {
          configArray = [
            this.selectField({
              key: fieldName,
              options: (config.possible_values || []).map((value) => {
                return { value: value, name: value }
              }),
              className: 'layout__item u-3/12 uiselect-dropdown-fit-content'
            }),
            this.comparisonField(['$in', '$nin'], fieldName),
            {className: 'layout__item u-2/12 layout--center', template: `<div class="u-pv--">{{ 'the' | translate | lowercase }} {{ 'last' | translate }}</div>`},
            this.numericInputField({key: 'inLastDays'}),
            {className: 'layout__item u-3/12', template: `<div class="u-pv--">{{ 'days' | translate | lowercase }}</div>`}
          ];
        }
      } else if (!_.isUndefined(inLastDaysComparison)) {
        if (this.isDateField(config)) { // e.g. regDate (a date within moving time range)
          configArray = [
            this.comparisonField(quantativeComparisons, 'date'),
            {className: 'layout__item u-2/12 layout--center', template: `<div class="u-pv--">{{ 'the' | translate | lowercase }} {{ 'last' | translate }}</div>`},
            this.numericInputField({key: 'inLastDays'}),
            {className: 'layout__item u-1/4', template: `<div class="u-pv--">{{ 'days' | translate | lowercase }}</div>`}
          ];
        } else if (this.isNumericField(config)) { // e.g. paidAmount (all time counter within moving time range)
          configArray = [
            this.comparisonField(['$gte', '$gt', '$lte', '$lt']),
            this.numericInputField({key: fieldName}),
            this.inLastDaysInputField()
          ];
        }
      } else if (!_.isEmpty(quantativeComparisons)) {
        if (this.isDateField(config)) { // e.g. regDate (a date with a comparison to a fixed date)
          configArray = [
            this.comparisonField(quantativeComparisons),
            this.selectField({key: fieldName, options: this.daysTranslated('#day'), className: 'layout__item u-2/6'})
          ];
        } else if (this.isNumericField(config) || this.isAlphaNumericField(config)) { // e.g. paidAmount (quantative all time comparison)
          configArray = [
            this.comparisonField(quantativeComparisons),
            this.numericInputField({key: fieldName})
          ];
        } else if (this.isBooleanField(config)) {
          configArray = [this.booleanField({key: fieldName})];
        }
      } else if (!_.isEmpty(multiSelectComparisons)) { // e.g. Platform (in,nin)
        if (config.field_label === 'Segment') {
          configArray = this.buildMatchingSegmentField(fieldName);
        }
        else if (this.isAlphaNumericField(config)) {
          configArray = [
            this.comparisonField(multiSelectComparisons),
            this.multiselectField({
              key: fieldName,
              options: (config.possible_values || []).map(option => {
                return {
                  value: option,
                  name: (/country/i).test(fieldName) ? this.translate(`countryCodes.${option}`) : option
                };
              }),
              className: 'layout__item u-5/6 uiselect-dropdown-fit-content'
            })
          ];
        } else if (this.isNumericField(config)) {
          if(fieldName == 'engaged' || fieldName == 'targeted' || fieldName == 'clicked') {
            configArray = [
              this.comparisonField(multiSelectComparisons, fieldName),
              this.multiselectField({
                key: fieldName,
                options: (this.campaigns).map(option => {
                  return {
                    value: option.id,
                    name:  option.name + ' (#' + option.id + ')'
                  };
                })
              })
            ];
          }
        }
      } else if (!_.isUndefined(existsComparison)) { // e.g facebookId (existence comparison)
        configArray = [this.existsField({key: fieldName})];
      }

      configArray = map(configArray, ({className, ...rest}) => ({
        className: this.withDisabledClassName(className),
        ...rest
      }));

      this.ruleFieldsForEachDimension[fieldName] = configArray || [];
    });

    this.dimensionFields = [
      {
        className: this.withDisabledClassName('layout__item u-1/1'),
        type: 'uiSelect',
        key: 'dimension',
        templateOptions: {
          label: '',
          options: _.chain(this.ruleFieldsForEachDimension).keys()
            .map((dimension) => {
              return {
                value: dimension,
                name: this.field_configs[dimension].field_label || dimension // never translate these fields
              };
            }).sortBy('name').value(),
          onChange: ($viewValue => this.onDimensionChange($viewValue)),
          required: true
        }
      }
    ];

    this.ruleFields = this.ruleFieldsForEachDimension[this.rule.dimension];
  }

  isNumericField(config) {
    return config.field_type === 'integer' || config.field_type === 'decimal';
  }

  isAlphaNumericField(config) {
    return config.field_type === 'string';
  }

  isDateField(config) {
    return config.field_type === 'date';
  }

  isBooleanField(config) {
    return config.field_type === 'bool'
  }

  setupFields() {
    this.defaults = {};
    _.forEach(this.field_configs, (config, key) => {
      if (!_.includes(config.comparisons, '$in_last_days')) {
        this.defaults[key] = config.comparisons[0];
      };
    })
  };

  comparisonField(comparisons, customTranslation) {
    customTranslation = customTranslation ? customTranslation + '.' : '';
    return this.selectField({
      key: 'comparison',
      className: 'layout__item u-1/6',
      options: comparisons.map(value => {
        return {value: value, name: this.translate('$rule.' + customTranslation + value)};
      })
    });
  }

  existsField({key}) {
    return {
      className: 'layout__item u-2/6',
      type: 'uiSelect',
      key: key,
      templateOptions: {
        label: '',
        options: [
          {value: true, name: this.translate('$rule.known')},
          {value: false, name: this.translate('$rule.unknown')}
        ],
        required: true
      }
    }
  }

  booleanField({key}) {
    return {
      className: 'layout__item u-2/6',
      type: 'uiSelect',
      key: key,
      templateOptions: {
        label: '',
        options: [
          {value: true, name: this.translate('true')},
          {value: false, name: this.translate('false')}
        ],
        required: true
      }
    }
  }

  daysTranslated(translateKey) {
    return [1, 3, 7, 14, 30]
      .map(value => {
        return {value: value, name: this.translate(translateKey, {count: value}, 'messageformat')};
      })
      .concat({value: 'lifetime', name: this.translate('lifetime')})
  }

  inLastDaysInputField() {
    return this.selectField({
      key: 'inLastDays',
      options: this.daysTranslated('#inLastDay'),
      className: 'layout__item u-2/6'
    });
  }

  inputField({key='value', className='layout__item u-1/6'}) {
    return {
      className: className,
      type: 'input',
      key: key,
      templateOptions: {
        label: '',
        required: true
      }
    }
  }

  numericInputField({key='value', className='layout__item u-1/6', hideExpression=undefined}) {
    return {
      className,
      type: 'inputDebounced',
      key,
      hideExpression,
      templateOptions: {
        label: '',
        required: true
      },
      validators: {
        isNumber: {
          expression: function ($viewValue, $modelValue, scope) {
            let value = $modelValue || $viewValue;
            let reg = /^(0|[1-9]([0-9]*))$/;
            return reg.test(value);
          }
        }
      }
    }
  }

  selectField({key='comparison', className='layout__item u-1/6', options=[]}) {
    return {
      className: className,
      type: 'uiSelect',
      key: key,
      templateOptions: {
        label: '',
        options: options,
        required: true
      }
    }
  }

  multiselectField({key='value', className='layout__item u-5/6', options=[]}) {
    return {
      className: className,
      type: 'uiSelectMultiple',
      key: key,
      templateOptions: {
        label: '',
        options: options,
        required: true
      }
    }
  }

  get first() {
    return this.rules[0] == this.rule;
  }

  onDimensionChange(dimension) {
    this.rule.comparison = this.defaults[dimension] || null;
    this.rule.inLastDays = (typeof this.defaults[dimension] === 'undefined') ? 7 : null;

    if (this.rule.comparison == '$exists') {
      this.rule[dimension] = true;
    }

    this.ruleFields = this.ruleFieldsForEachDimension[dimension];
  }

  remove() {
    this.rules = _.without(this.rules, this.rule);
  }

  addSubrule() {
    this.rule.children = this.rule.children || [];
    this.rule.children.push({
      child: true,
      logical: '$and'
    });
  }
}

export function SegmentsRuleComponent() {
  return {
    template,
    controller: SegmentsRuleController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: {
      rule: '=',
      rules: '=',
      campaigns: '=',
      gameDeveloperGames: '='
    }
  };
};

export default angular.module('app.components.segments.rule', [
  ConfigsModule.name,
  ObservablesModule.name,
  ResourcesModule.name
])
.directive('segmentsRule', SegmentsRuleComponent);



/** WEBPACK FOOTER **
 ** ./src/components/segments/segmentsRule.js
 **/